import FinancialFieldsContainer from './FinancialFieldsContainer';

export default FinancialFieldsContainer;
